import {Box} from '@mantine/core';
import type React from 'react';
import {useEffect} from 'react';
import {COMPANY_FOLLOW_RANKING} from '../../../../../config/constants/routes';
import {CONSULTANT_INDUSTRIES} from '../../../../../core/entities/company/constants';
import type {IndustryCategoriesReturnValueType} from '../../../../../core/repositories/reportsRepository';
import {CommonLink} from '../../../../../shared/components/CommonLink';

type Props = {
  industryCategories?: IndustryCategoriesReturnValueType;
  isEngineer: boolean;
  isDisplayPickup: boolean;
  isDisplayRanking: boolean;
};

export const CompanyTagSelector: React.FC<Props> = ({
  industryCategories,
  isEngineer,
  isDisplayPickup,
  isDisplayRanking,
}) => {
  const categories = industryCategories?.ok
    ? industryCategories.value.industryCategories.filter(
        (category) => category.id !== 1,
      )
    : [];

  // TODO: URLの設定
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const overflowElement = window.document.querySelector('selector');
    if (!overflowElement) {
      return;
    }

    if (overflowElement.scrollLeft !== 0) {
      overflowElement.scrollLeft = 0;
    }
  }, []);

  const commonStyle =
    'text-base text-primary font-bold border-2 border-primary rounded-[20px] px-8 py-4 pc:px-16 pc:py-8 text-nowrap hover:cursor-pointer';

  return (
    <Box className="mt-16 p-16 pc:bg-white pc:my-16 pc:w-[1200px] pc:rounded-[20px] pc:shadow-card">
      <Box
        id={'selector'}
        className="flex justify-around gap-8 overflow-x-scroll"
      >
        {isDisplayPickup && (
          <CommonLink className={commonStyle} href={'#pickup'}>
            外資就活ピックアップ
          </CommonLink>
        )}

        {isDisplayRanking && (
          <CommonLink className={commonStyle} href={COMPANY_FOLLOW_RANKING}>
            ランキング
          </CommonLink>
        )}

        {isEngineer && (
          <CommonLink
            className={commonStyle}
            href={'/company/industry/engineer'}
            key={'engineer'}
          >
            エンジニア
          </CommonLink>
        )}
        {CONSULTANT_INDUSTRIES.map((industry) => (
          <CommonLink
            className={commonStyle}
            href={`/company/industry/1?industryIDs=${industry.ids.join(',')}`}
            key={industry.ids[0]}
          >
            {industry.name}
          </CommonLink>
        ))}
        {categories.map((category) => (
          <CommonLink
            className={commonStyle}
            href={`/company/industry/${category.id}`}
            key={category.id}
          >
            {category.name}
          </CommonLink>
        ))}
        {!isEngineer && (
          <CommonLink
            className={commonStyle}
            href={'#engineer'}
            key={'engineer'}
          >
            エンジニア
          </CommonLink>
        )}
      </Box>
    </Box>
  );
};
